<template>
    <vs-row>
        <vs-row vs-justify="center">
            <vs-col vs-lg="4" class="mt-5 pt-5">
                <img src="@/assets/images/logo/logo.png" width="100%" class="logoStyle"/>
            </vs-col>
        </vs-row>
        <vs-row vs-justify="center">
            <h4 class="mb-3">Reset your password!</h4>
        </vs-row>
        <vs-row vs-justify="center" class="mt-6">
            <vs-col vs-lg="3" class="inputStyle mt-6">
                <div class="mt-6">
                    Please enter your new password
                </div>
                <vs-input 
                v-model="password"
                 placeholder="New Password"
                class="w-full" 
                type="password"
                :danger="errors.password.success"
                :danger-text="errors.password.msg"
                @input="validatePassword($event)"
                maxLength="30"
    />
            </vs-col>
        </vs-row>
        <vs-row vs-justify="center" class="mt-0">
            <vs-col vs-lg="3" class="inputStyle mt2">
                <vs-input 
                v-model="password2"
                 placeholder="Confirm Password"
                class="w-full" type="password"
                :danger="errors.password2.success"
                :danger-text="errors.password2.msg"
                maxLength="30"
                />
            </vs-col>
        </vs-row>
        <vs-row vs-justify="center" class="my-6 py-4">
            <vs-col vs-lg="3" class="inputStyle" vs-type="flex" vs-justify="flex-end">
                <vs-button class="w-full py-4 my-6" @click="resetPassword">Reset Password</vs-button>
            </vs-col>
        </vs-row>
    </vs-row>
</template>

<script>
import axios from 'axios';
import { genericErrorMessage, toast } from '@/keys/toast-messages';

export default {
    data(){
        return {
            password: '',
            password2: '',
            token: '',

            errors: {
                password: {
                    msg: '',
                    success: false
                },
                password2: {
                    msg: '',
                    success: false
                }
            },

            genericErrorMessage,
            toast
        }
    },
    created(){
        this.token = this.$route.params.token;
    },
    methods: {
        async resetPassword(){
            await this.validatePassword(this.password);
            await this.validateResetPassword(this.password2);
            if(!this.errors.password.success && !this.errors.password2.success){
                return new Promise((resolve, reject) => {
                    axios.post(this.$ApiKeys.BASE_URL+this.$EndPoints.ResetPassword,{
                        password: this.password,
                        password2: this.password2,
                        token: this.token,
                        
                    }).then(async res => {
                        if(res.data.success){
                            if(res.data.msg == "The account password has been reset. Please log in."){
                                this.$router.push({ name: 'admin-login', params: { token: this.token } })
                            }
                        } else {
                            this.toast(this.genericErrorMessage());
                        }
                    }).catch(e => {
                        if(e.response.status !== 401){
                            this.toast(this.genericErrorMessage());
                        }
                        // console.log("Error in Reset Password: ",e.response);
                    });
                });
            }
        },
       validatePassword(value){
            if(value == '' || !value.trim()){
                this.errors.password = {
                msg: 'Password is required',
                success: true
            }
            } else {
                this.errors.password = {
                msg: '',
                success: false
                }
            }
        },
        validateResetPassword(value){
            if(value == '' || !value.trim()){
                this.errors.password2 = {
                msg: 'Confirm Password is required',
                success: true
            }
            } else {
                if(this.password != this.password2) {
                    this.errors.password2 = {
                        msg: 'Confrim Password is not matched',
                        success: true
                    }
                }
                else {
                    this.errors.password2 = {
                        msg: '',
                        success: false
                    }
                }
            }
        }
    }
}
</script>


<style>

    .theme-dark .input-icon-validate {
    display: none !important; 
    }
    .theme-dark .con-text-validation {
    font-size:12px !important;
    }

    .logoStyle {
        padding: 15%;
    }
    .inputStyle .vs-input--input, .inputStyle .vs-input--placeholder {
        padding: 4% 4% !important;
        padding-top: 4% !important;
        margin: 5% 0 !important;
    }
     .inputStyle .vs-input--placeholder {
            font-size: 100%;
            margin-top: 4.5% !important;
     } 
    .signUpLink {
        color:#4B4BF9;
    }
</style>
